// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__G-kFf","legacyBtn":"MutateMid_legacyBtn__2yV1C"};